import axios from 'axios'

import { getShopDomain } from '@/utils/auth.js'

const SHOP_DOMAIN = getShopDomain()
const SHARE_API_URL = `${SHOP_DOMAIN}/share`

/**
  * Function to create a share link via back-end API.
  * @param {function} callback a callback function to handle resolve.
  * @param {object} filters the current product filters to be stored with share.
  */
export function createShareLink (callback, filters = {}) {
  const data = filters
  const url = SHARE_API_URL

  axios({
    method: 'post',
    url: url,
    data: {
      // duration: 0, // uncomment to test share link expiration (in seconds)
      ...data
    }
  })
  .then(function (response) {
    // success
    if (callback && typeof callback === 'function') {
      const {
        id
      } = response.data

      callback(id)
    }
  })
  .catch(function (error) {
    // failed
    console.log('Error retrieving share link.')
    console.log(error)
  })
}

/**
  * Function that returns a share link url.
  * @param {string} id the share link identifier.
  */
export function getShareLinkUrl (id, productId) {
  const protocol = window.location.protocol
  const hostname = window.location.host
  // const port = window.location.port
  const pathname = window.location.pathname
  // const rootUrl = `${protocol}//${hostname}${port && ':'}${port}/${pathname}`
  const rootUrl = `${protocol}//${hostname}`
  const queryString = `?share=${id}&domain=${SHOP_DOMAIN}`
  let fullUrl = ''

  if (productId) {
    fullUrl = `${rootUrl}/product/${productId}${queryString}&detail=1`
  } else {
    fullUrl = `${rootUrl}${pathname}${queryString}&detail=0`
  }

  return fullUrl
}

/**
  * Function to validate a share link via back-end API.
  * @param {function} successCallback a callback function to handle resolve.
  * @param {function} errorCallback a callback function to handle errors.
  * @param {string} id the share link identifier.
  */
export function validateShareLink (successCallback, errorCallback, id = '', domain = null) {
  const url = `${domain}/share/${id}`

  axios({
    method: 'get',
    url: url,
    validateStatus: function (status) {
      // return status >= 200 && status < 300 // axios default
      return status >= 200 && status < 500
    }
  })
  .then(function (response) {
    // success
    if (successCallback && typeof successCallback === 'function') {
      const {
        status
      } = response

      const {
        data
      } = response.data

      successCallback(status, data, response)
    }
  })
  .catch(function (error) {
    // failed
    if (errorCallback && typeof errorCallback === 'function') {
      console.log('Error validating share link.')
      console.log(error)

      errorCallback()
    }
  })
}



// WEBPACK FOOTER //
// ./src/js/utils/share.js